export interface DecisionEngine {
  decision: DecisionStatus;
  reasons: string[];
  redirect_url?: string;
  redirect_mode?: LoanRedirectMode;
}

export enum DecisionStatus {
  DENIED = 'DENIED',
  APPROVED = 'APPROVED',
  MISSING_DATA = 'MISSING DATA',
  PENDING = 'DECISION PENDING',
  NOT_NECESSARY = 'NOT NECESSARY',
  NO_DECISION = 'NO_DECISION',
  COUNTER_OFFER = 'COUNTER_OFFER',
}

export enum LoanRedirectMode {
  INT = 'INTERACTIVE',
  AUTO = 'AUTO',
}
